export const DEFAULT_MAX_WEIGHT = 180;
